import React from 'react'
import VIEWS from '../store/views'
import Username from './username'
import Ssn from './ssn'
import Dob from './dob'

const ProviderComponent = ({ viewName }) => (
  <div className="username-container">
    {viewName === VIEWS.username.name ? (
      <Username />
    ) : (
      <React.Fragment>
        <Ssn />
        <Dob />
      </React.Fragment>
    )}
  </div>
)

ProviderComponent.displayName = 'ProviderComponent'

export default ProviderComponent
